import { render, staticRenderFns } from "./GalleryTop.vue?vue&type=template&id=c4651016&scoped=true&"
import script from "./GalleryTop.vue?vue&type=script&lang=js&"
export * from "./GalleryTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4651016",
  null
  
)

export default component.exports